import { Frequency, RRule } from "rrule";

export const MonthStrToIndexMap: Record<string, number> = {
  january: 1,
  february: 2,
  march: 3,
  april: 4,
  may: 5,
  june: 6,
  july: 7,
  august: 8,
  september: 9,
  october: 10,
  november: 11,
  december: 12,
};

// Add 1 to get the 1 based index of the months
export const IndexToMonthStr: string[] = [
  "january",
  "february",
  "march",
  "april",
  "may",
  "june",
  "july",
  "august",
  "september",
  "october",
  "november",
  "december",
];

export const weekdayStrMap = {
  [RRule.MO.toString()]: RRule.MO.weekday,
  [RRule.TU.toString()]: RRule.TU.weekday,
  [RRule.WE.toString()]: RRule.WE.weekday,
  [RRule.TH.toString()]: RRule.TH.weekday,
  [RRule.FR.toString()]: RRule.FR.weekday,
  [RRule.SA.toString()]: RRule.SA.weekday,
  [RRule.SU.toString()]: RRule.SU.weekday,
};

export const FrequencySelectOptions = [
  [Frequency.DAILY.toString(), "Day"],
  [Frequency.WEEKLY.toString(), "Week"],
  [Frequency.MONTHLY.toString(), "Month"],
  // [Frequency.QUARTERLY, "Quarter"],
  [Frequency.YEARLY.toString(), "Year"],
].map((v) => ({
  key: v[0],
  value: v[0],
  label: v[1] as string,
}));
